export default "__VITE_ASSET__9krM82xx__"